const DICTIONARY_ESTADOS = {
    MS: `Mato Grosso do Sul`,
    PR: `Paraná`,
    SC: `Santa Catarina`
}

export default DICTIONARY_ESTADOS